<template>
  <div class="paymentForm">
    <!-- <el-button
      type="primary"
      class="fixed-bottom-btn"
      v-hasPermi="['2021050810302011808']"
      @click="handleAccountEntry"
      >生成解付凭证</el-button
    >
    <el-button
      type="primary"
      class="fixed-bottom-btn"
      v-hasPermi="['2021050810303795861']"
      @click="doSyncVoucherForEntityData()"
      >过账解付凭证</el-button
    >
    <el-button
      type="primary"
      class="fixed-bottom-btn"
      v-hasPermi="['2021050810305329147']"
      @click="doReverseAccountEntry"
      >冲销解付凭证</el-button
    > -->
    <base-form
      style="margin-top: 10px"
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      :disabled="!isEdit || !canEdit"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
    <voucher
      ref="voucher"
      :voucherList="voucherList"
      @reverseInfo="reverseInfo"
      @postInfo="postInfo"
    ></voucher>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import voucherMixins from '@/common/mixins/voucher.js';
  export default {
    name: 'paymentForm',
    mixins: [voucherMixins],
    components: {
      baseForm,
    },
    props: ['isEdit', 'canEdit'],
    data() {
      return {
        baseData: {
          id: null,
          marginPayAmount: null,
          marginBankAccount: null,
          payAmount: null,
          payDate: null,
          bankUnionNumber: null,
          bankAccount: null,
          cashflowCode: '120101',
          accountingStatus: null,
        },
        voucherFlag: 'AE_AP_BILL', //凭证标识
      };
    },
    computed: {
      baseDataOptions() {
        //基础数据表单配置
        return [
          /* {
            // 保证金解付金额
            type: 'amountNumber',
            label: this.$t('billDetail.paymentForm.marginPayAmount'),
            prop: 'marginPayAmount',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 保证金支付银行
            type: 'input',
            label: this.$t('billDetail.paymentForm.marginBankAccount'),
            prop: 'marginBankAccount',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
            required: this.baseData.marginPayAmount && this.baseData.marginPayAmount != 0,
          }, */
          {
            // 存款解付金额
            type: 'amountNumber',
            label: this.$t('billDetail.paymentForm.payAmount'),
            prop: 'payAmount',
            max: 99999999999.99,
            min: 0,
          },
          {
            // 解付日期
            type: 'date',
            label: this.$t('billDetail.paymentForm.payDate'),
            prop: 'payDate',
          },
          {
            // 解付银行行号
            type: 'searchTable',
            prop: 'bankUnionNumber',
            searchType: 'bankAccount',
            isMultiple: true,
            label: this.$t('billDetail.paymentForm.bankUnionNumber'),
            currentValue: this.baseData.bankUnionNumber,
          },
          /* {
            // 现金流量代码
            type: 'searchTable',
            label: this.$t('billDetail.paymentForm.cashflowCode'),
            prop: 'cashflowCode',
            searchType: 'cashflow',
            isMultiple: true,
            currentValue: this.baseData.cashflowCode,
          },
          {
            // 解付入账状态
            type: 'dict',
            dictType: 'post_status',
            label: this.$t('billDetail.paymentForm.accountingStatus'),
            prop: 'accountingStatus',
            placeholder: this.$t('billDetail.placeholder.auto'),
            disabled: true,
          }, */
        ];
      },
    },
    methods: {
      handleChangeBaseData(value, prop) {
        //基本数据表单变化
        if (prop == 'marginPayAmount') {
          this.$emit('marginBankAccountChange');
        } else if (prop == 'bankUnionNumber') {
          this.searchTableChange(value.bankUnionNumber, [
            { val: 'bankAccount', getVal: 'bankAccountNum' },
            { val: 'bankUnionNumber', getVal: 'bankUnionNumber' },
          ]);
        } else if (prop == 'cashflowCode') {
          this.searchTableChange(value.cashflowCode, [{ val: 'cashflowCode' }]);
        }
      },
      searchTableChange(val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              this.baseData[item.val] = val[0][item.getVal];
            } else {
              this.baseData[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            this.baseData[item.val] = null;
          });
        }
      },
      exportChildData() {
        // 返回数据
        let sign = false;
        this.$refs.baseData.$refs.ruleForm.validate((valid) => {
          if (valid) {
            sign = true;
          } else {
            sign = false;
          }
        });
        return sign ? this.baseData : false;
      },
      getData() {
        this.$emit('getData');
      },
    },
  };
</script>
